import { useEffect, useState } from "react";
import axios from "axios";
import "../CriarVaga/CriarVaga.css";

export default function EditaVaga({
    aberto,
    onClose,
    atualizarVagas,
    vaga
}) {

    const [nomeVaga, setNomeVaga] =
        useState("");

    const [cidade, setCidade] =
        useState("");

    const [endereco, setEndereco] =
        useState("");

    const [horario, setHorario] =
        useState("");

    const [descricao, setDescricao] =
        useState("");

    const [atividade, setAtividade] =
        useState("");

    const [atividades, setAtividades] =
        useState([]);

    const [requisito, setRequisito] =
        useState("");

    const [requisitos, setRequisitos] =
        useState([]);

    const [beneficio, setBeneficio] =
        useState("");

    const [beneficios, setBeneficios] =
        useState([]);

    const [loading, setLoading] =
        useState(false);

    const [erro, setErro] =
        useState("");

    useEffect(() => {

        if (!aberto || !vaga) {
            return;
        }

        setNomeVaga(vaga.vaga ?? "");

        setCidade(vaga.cidade ?? "");

        setEndereco(vaga.endereco ?? "");

        setHorario(vaga.desc_horario ?? "");

        setDescricao(vaga.desc_vaga ?? "");

        setAtividades(
            vaga.atividades
                ? vaga.atividades.map(
                    item => item.descricao
                )
                : []
        );

        setRequisitos(
            vaga.requisitos
                ? vaga.requisitos.map(
                    item => item.descricao
                )
                : []
        );

        setBeneficios(
            vaga.beneficios
                ? vaga.beneficios.map(
                    item => item.descricao
                )
                : []
        );

        setErro("");

        setAtividade("");

        setRequisito("");

        setBeneficio("");

    }, [aberto, vaga]);

    if (!aberto) return null;

    function adicionarAtividade() {

        if (!atividade.trim()) {
            return;
        }

        setAtividades([
            ...atividades,
            atividade.trim()
        ]);

        setAtividade("");

    }

    function adicionarRequisito() {

        if (!requisito.trim()) {
            return;
        }

        setRequisitos([
            ...requisitos,
            requisito.trim()
        ]);

        setRequisito("");

    }

    function adicionarBeneficio() {

        if (!beneficio.trim()) {
            return;
        }

        setBeneficios([
            ...beneficios,
            beneficio.trim()
        ]);

        setBeneficio("");

    }

    function removerAtividade(index) {

        setAtividades(
            atividades.filter(
                (_, i) => i !== index
            )
        );

    }

    function removerRequisito(index) {

        setRequisitos(
            requisitos.filter(
                (_, i) => i !== index
            )
        );

    }

    function removerBeneficio(index) {

        setBeneficios(
            beneficios.filter(
                (_, i) => i !== index
            )
        );

    }

    async function editarVaga() {

        setErro("");

        if (
            !nomeVaga ||
            !cidade ||
            !endereco ||
            !horario ||
            !descricao
        ) {

            setErro(
                "Preencha todos os campos obrigatórios."
            );

            return;

        }

        const body = {

            id: vaga.id,

            vaga: nomeVaga,

            cidade,

            endereco,

            desc_horario: horario,

            desc_vaga: descricao,

            atividades,

            requisitos,

            beneficios

        };

        try {

            setLoading(true);

            console.log("BODY EDITAR:");

            console.log(body);

            await axios.put(
                "https://app.eliandroalimentos.com.br/api/vagas/editarvaga",
                body
            );

            await atualizarVagas();

            onClose();

        } catch (err) {

            console.log(err);

            if (err.response?.data?.error) {

                setErro(
                    err.response.data.error
                );

            } else if (
                err.response?.data?.errors
            ) {

                setErro(
                    err.response.data.errors
                        .map(
                            e => e.msg
                        )
                        .join(" | ")
                );

            } else {

                setErro(
                    "Erro ao editar vaga."
                );

            }

        } finally {

            setLoading(false);

        }

    }
    
    return (

    <div
        className="criarvaga-overlay"
        onClick={onClose}
    >

        <div
            className="criarvaga-card"
            onClick={(e) =>
                e.stopPropagation()
            }
        >

            <h2>
                Editar Vaga
            </h2>

            {/* Nome e Cidade */}

            <div className="criarvaga-grid">

                <div>

                    <label>
                        Nome da vaga *
                    </label>

                    <input
                        value={nomeVaga}
                        onChange={(e) =>
                            setNomeVaga(
                                e.target.value
                            )
                        }
                    />

                </div>

                <div>

                    <label>
                        Cidade *
                    </label>

                    <input
                        value={cidade}
                        onChange={(e) =>
                            setCidade(
                                e.target.value
                            )
                        }
                    />

                </div>

            </div>

            {/* Endereço e Horário */}

            <div className="criarvaga-grid2">

                <div>

                    <label>
                        Endereço *
                    </label>

                    <input
                        value={endereco}
                        onChange={(e) =>
                            setEndereco(
                                e.target.value
                            )
                        }
                    />

                </div>

                <div>

                    <label>
                        Horário *
                    </label>

                    <input
                        value={horario}
                        onChange={(e) =>
                            setHorario(
                                e.target.value
                            )
                        }
                    />

                </div>

            </div>

            <label>
                Descrição da vaga *
            </label>

            <textarea
                rows={4}
                value={descricao}
                onChange={(e) =>
                    setDescricao(
                        e.target.value
                    )
                }
            />

            {/* LISTAS */}

            <div className="criarvaga-listas">

                {/* Atividades */}

                <div className="lista-box">

                    <h3>
                        Atividades
                    </h3>

                    <div className="linha-add">

                        <input
                            value={atividade}
                            onChange={(e) =>
                                setAtividade(
                                    e.target.value
                                )
                            }
                        />

                        <button
                            type="button"
                            onClick={
                                adicionarAtividade
                            }
                        >
                            Adicionar
                        </button>

                    </div>

                    <div className="itens-lista">

                        {atividades.map(
                            (
                                item,
                                index
                            ) => (

                                <div
                                    key={index}
                                    className="item-lista"
                                >

                                    <span>
                                        {item}
                                    </span>

                                    <button
                                        type="button"
                                        className="btn-remover"
                                        onClick={() =>
                                            removerAtividade(
                                                index
                                            )
                                        }
                                    >
                                        ✕
                                    </button>

                                </div>

                            )
                        )}

                    </div>

                </div>

                {/* Requisitos */}

                <div className="lista-box">

                    <h3>
                        Requisitos
                    </h3>

                    <div className="linha-add">

                        <input
                            value={requisito}
                            onChange={(e) =>
                                setRequisito(
                                    e.target.value
                                )
                            }
                        />

                        <button
                            type="button"
                            onClick={
                                adicionarRequisito
                            }
                        >
                            Adicionar
                        </button>

                    </div>

                    <div className="itens-lista">

                        {requisitos.map(
                            (
                                item,
                                index
                            ) => (

                                <div
                                    key={index}
                                    className="item-lista"
                                >

                                    <span>
                                        {item}
                                    </span>

                                    <button
                                        type="button"
                                        className="btn-remover"
                                        onClick={() =>
                                            removerRequisito(
                                                index
                                            )
                                        }
                                    >
                                        ✕
                                    </button>

                                </div>

                            )
                        )}

                    </div>

                </div>

                {/* Benefícios */}

                <div className="lista-box">

                    <h3>
                        Benefícios
                    </h3>

                    <div className="linha-add">

                        <input
                            value={beneficio}
                            onChange={(e) =>
                                setBeneficio(
                                    e.target.value
                                )
                            }
                        />

                        <button
                            type="button"
                            onClick={
                                adicionarBeneficio
                            }
                        >
                            Adicionar
                        </button>

                    </div>

                    <div className="itens-lista">

                        {beneficios.map(
                            (
                                item,
                                index
                            ) => (

                                <div
                                    key={index}
                                    className="item-lista"
                                >

                                    <span>
                                        {item}
                                    </span>

                                    <button
                                        type="button"
                                        className="btn-remover"
                                        onClick={() =>
                                            removerBeneficio(
                                                index
                                            )
                                        }
                                    >
                                        ✕
                                    </button>

                                </div>

                            )
                        )}

                    </div>

                </div>

            </div>

            {erro && (

                <div className="erro-vaga">

                    {erro}

                </div>

            )}

            <div className="rodape-modal">

                <button
                    type="button"
                    className="btn-cancelar"
                    onClick={onClose}
                >
                    Cancelar
                </button>

                <button
                    type="button"
                    className="btn-salvar"
                    disabled={loading}
                    onClick={editarVaga}
                >
                    {loading
                        ? "Salvando..."
                        : "Salvar Alterações"}
                </button>

            </div>

        </div>

    </div>

);}